import { useMatch } from 'react-router';

import {
  INTRANET_LIBRARY_PATH,
  INTRANET_NEWS_PATH,
  INTRANET_ROOT,
} from '@/products/intranet/intranet-paths';

/** Shared route flags for hero, tab nav and the channel trigger. */
export function useIntranetChrome() {
  const onHome = useMatch({ path: INTRANET_ROOT, end: true }) !== null;
  const onNewsArticle = useMatch({ path: `${INTRANET_NEWS_PATH}/:slug` }) !== null;
  const onLibraryArticle = useMatch({ path: `${INTRANET_LIBRARY_PATH}/:slug` }) !== null;
  const onArticle = onNewsArticle || onLibraryArticle;
  return { onHome, onArticle };
}

/** Hide product chrome on phones when reading an article; desktop keeps the rails. */
export const INTRANET_MOBILE_ARTICLE_CHROME_CLASS = 'max-lg:hidden';
